import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import anime from 'animejs';
import { throttle } from 'lodash-es';
import { ref } from 'vue';

export type SharedMagneticBlobEmits = {
	(e: 'pathClick'): void
};
export type SharedMagneticBlobProps = {
	proximityFactor: number
	curveFactor: number
	side: 'right' | 'left'
};

export default class SharedMagneticBlobSetup extends BaseSetup {

	static readonly defaultProps = {
		proximityFactor: 1,
		curveFactor: 1,
		side: 'right' as const,
	};

	readonly _el = ref<HTMLElement>();
	readonly _v = ref<SVGElement>();
	@Reactive private readonly state = {
		x: 0,
		y: 50,
	};

	get x () { return this.state.x }
	get y () { return this.state.y }

	constructor (
		private props: SharedMagneticBlobProps,
		private emits: SharedMagneticBlobEmits,
	) {
		super();
		this.initMouseMoveListener();
	}

	private mouseMoveListenerThrottle = throttle((e: MouseEvent) => {
		if (!this._el.value || !this._v.value) return;

		const { top, bottom, height, right, left } = this._el.value?.getBoundingClientRect();

		let relativeY = 0;
		let relativeX = 0;

		if (this.props.side === 'left' || this.props.side === 'right') {
			relativeY = e.clientY <= top
				? 0
				: e.clientY >= bottom
					? 100
					: (e.clientY - top) * 100 / height;

			if (this.props.side === 'right') {
				relativeX = e.clientX < left
					? 0
					: e.clientX > right
						? 100 - ((e.clientX - right) / this.props.proximityFactor)
						: 100;
			}
			else if (this.props.side === 'left') {
				relativeX = e.clientX > right
					? 0
					: e.clientX < left
						? 100 - ((left - e.clientX) / this.props.proximityFactor)
						: 100;
			}
		}

		this.state.x = (relativeX < 0 ? 0 : relativeX);
		this.state.y = relativeY;

		const topHandlerY = relativeY - 10;
		const factoredTopHandlerY = relativeY - (10 / this.props.curveFactor);
		// const bottomHandlerY = relativeY + 10;
		const factoredBottomHandlerY = relativeY + (10 / this.props.curveFactor);

		anime({
			targets: this._v.value.getElementsByTagName('path').item(0),
			d: `M0,0 C0,${factoredTopHandlerY}, ${this.x * 0.9},${topHandlerY} ${this.x * 0.9},${this.y} S 0,${factoredBottomHandlerY} 0,100`,
			duration: 300,
		});
	}, 10);

	private initMouseMoveListener () {
		document.addEventListener('mousemove', this.mouseMoveListenerThrottle.bind(this));
	}

	handlePathClick () {
		this.emits('pathClick');
	}

}
